export default "__VITE_ASSET__wC7qDFsA__"